<h3 class="with-manual-link">
  <span i18n="@@user-values">Datenspeicher</span>
</h3>
<div class="mb-3">
  <div class="row mb-3">
    <div class="col-3">
      <span i18n="@@filter-results">Ergebnisse Filtern</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.filterString"
        (ngModelChange)="this.filterKeyvals()"
        fluid
      >
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <span i18n="@@export-results">Ergebnisse Exportieren</span>
    </div>
    <div class="col">
      <rag-excel-export
        [data]="this.exportData"
        [config]="this.exportConfig"
      ></rag-excel-export>
    </div>
  </div>
</div>

<p-table
  [value]="this.filteredKeyVals"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th>
        <span i18n="@@user-identifier">Nutzerkennung</span>
      </th>
      <th>
        <span i18n="@@key">Schlüssel</span>
      </th>
      <th>
        <span i18n="@@value">Wert</span>
      </th>
      <th>
        <span i18n="@@grouped">Gruppierung</span>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-keyval
  >
    <tr>
      <td>{{ this.getUserByContext(keyval.context) }}</td>
      <td>{{ keyval.key }}</td>
      <td>{{ keyval.value }}</td>
      <td>{{ keyval.type }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="4"
        class="text-center p-5 text-muted"
        i18n="@@user-values-empty"
      >
        Noch kein Datenspeicher vorhanden.
      </td>
    </tr>
  </ng-template>
</p-table>